// import getBaseUrl from "@/lib/config";
import { SignIn } from "@clerk/clerk-react";

export default function SignInPage() {
    return(
        <div className="items-center flex min-h-screen w-full justify-center bg-gray-50 dark:bg-gray-900">
            <SignIn
                routing="path"
                path="/sign-in"
                // redirectUrl={`${getBaseUrl()}/`}
                // afterSignOutUrl={`${getBaseUrl()}`}
            />
        </div>
    )
}
